import { Object3D } from 'three'
import * as TWEEN from '@tweenjs/tween.js'

import { animateChangeMeshes, TOpacityOption } from '../utils/animate-change-meshes'
import { Configurator } from './Configurator/Configurator'
import { DiamondCut } from '../../../../trillion-common/src/objects/diamond-cut.object'
import { useAppStore } from '../../shared/store/store'
import { ANIMATION_DURATION } from '../../viewerSettings'

interface SelectCutProps {
  model: Object3D | undefined
  diamondCuts: Array<DiamondCut>
}

export const SelectCut = ({ model, diamondCuts }: SelectCutProps) => {
  const currentDiamondCut = useAppStore((state) => state.currentDiamondCut)
  const setCurrentDiamondCut = useAppStore((state) => state.setCurrentDiamondCut)

  let tweenOut: TWEEN.Tween<TOpacityOption>
  let tweenIn: TWEEN.Tween<TOpacityOption>

  function changeCut(model: Object3D, currentIndex: number, prevIndex: number) {
    setCurrentDiamondCut(diamondCuts[currentIndex])

    if (tweenIn) TWEEN.remove(tweenIn)
    if (tweenOut) TWEEN.remove(tweenOut)
    for (const group of model.children) {
      const prevMeshes: Array<Object3D> = []
      const currentMeshes: Array<Object3D> = []

      for (const mesh of group.children) {
        diamondCuts.forEach((cut, index) => {
          if (mesh.name === cut.name || mesh.name === cut.frame) {
            mesh.visible = false
            if (prevIndex > -1 && index === prevIndex) {
              prevMeshes.push(mesh)
            } else if (index === currentIndex) {
              currentMeshes.push(mesh)
            }
          }
        })
      }

      if (prevIndex > -1) {
        tweenOut = animateChangeMeshes(prevMeshes, 0, 'out')
      }
      tweenIn = animateChangeMeshes(currentMeshes, prevIndex > -1 ? ANIMATION_DURATION : 0, 'in')
    }
  }

  return (
    <Configurator
      model={model}
      items={diamondCuts}
      currentItem={currentDiamondCut}
      title={'diamond cut'}
      onChange={changeCut}
    />
  )
}
